import React from "react";
import styles from "../Submenu.module.css";

const ColumnWrapper = (
  props: React.DetailedHTMLProps<
    React.LiHTMLAttributes<HTMLLIElement>,
    HTMLLIElement
  >,
) => (
  <li
    {...props}
    className={`${styles.submenu__columnWrapper} submenu__columnWrapper`}
  />
);

export default ColumnWrapper;
